/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_Reason_RequiredInputs */

const cs_viewings_reason_required = /** @type {(inputs: Viewings_Reason_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte důvod při označení jako nekoupil.`)
};

const en_viewings_reason_required = /** @type {(inputs: Viewings_Reason_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a reason when marking as not purchased.`)
};

/**
* | output |
* | --- |
* | "Select a reason when marking as not purchased." |
*
* @param {Viewings_Reason_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_reason_required = /** @type {((inputs?: Viewings_Reason_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_Reason_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_reason_required(inputs)
	return cs_viewings_reason_required(inputs)
});